import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { loadConfig } from '@/lib/config';
import { queryClient } from '@/lib/trpc';
import { router } from '@/router';
import '@/styles/index.css';

async function boot(): Promise<void> {
  const cfg = await loadConfig();
  document.title = cfg.productName;
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

boot().catch((err: unknown) => {
  const root = document.getElementById('root');
  if (root) root.textContent = `Could not load configuration: ${(err as Error).message}`;
});
